<template>
  <v-app>

    <!-- left navigation -->
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      disable-resize-watcher
      fixed
      app
      floating
      class="hidden-md-and-up"
    >
      <v-toolbar  class="transparent" flat>
        <v-list class="pa-0">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <!--<img src="https://randomuser.me/api/portraits/men/85.jpg" >-->
              <img src="https://cdn.vuetifyjs.com/images/logos/v-alt.svg" alt="user">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title><span class="grey--text text--darken-3">{{ currentUser }}</span></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      
    
      <v-list>
        <template value="true"
            v-for="(item, i) in items">
          <v-list-tile
            :key="i"
            @click="redirect(item)"
            v-if="item.needPermission && hasPermissions"
          >
            <v-list-tile-action>
              <v-icon v-html="item.icon" color="grey darken-3"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span class="grey--text text--darken-3">
                  {{ item.title }}
                </span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            :key="i"
            @click="redirect(item)"
            v-if="!item.needPermission"
          >
            <v-list-tile-action>
              <v-icon v-html="item.icon" color="grey darken-3"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span class="grey--text text--darken-3">
                  {{ item.title }}
                </span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    

    <!-- toolbar -->
    <v-toolbar 
      app
      :clipped-left="clipped" dark fixed color="light-blue darken-3"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <v-avatar
          :tile="tile"
          :size="avatarSize"
          style="margin-left: 16px !important;"
        >
        <img class="pointer" @click="redirectHome" src="https://cdn.vuetifyjs.com/images/logos/v-alt.svg" alt="avatar">
        </v-avatar>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <!--<v-toolbar-items>
        <v-btn flat>Link One</v-btn>
        <v-btn flat>Link Two</v-btn>
        <v-btn flat>Link Three</v-btn>
      </v-toolbar-items>-->
      <!--<v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>-->
      <v-menu offset-y class="hidden-md-and-down">
      <v-btn slot="activator" color="" icon>
          <v-icon >menu</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile avatar  value="true">
            <!--<v-list-tile-avatar>
              <img src="http://svgur.com/i/65U.svg" alt="user">
            </v-list-tile-avatar>-->
            <v-list-tile-action>
                <v-icon color="grey darken-3">account_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title><span class="grey--text text--darken-3">{{ currentUser }}</span></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        <v-divider></v-divider>
        <template v-for="(item, index) in items"  value="true">
          <v-list-tile  @click="redirect(item)" :key="index" v-if="item.needPermission && hasPermissions">
                <v-list-tile-action>
                <v-icon v-html="item.icon" color="grey darken-3"></v-icon>
              </v-list-tile-action>
              <v-list-tile-title><span class="grey--text text--darken-3">{{ item.title }} </span></v-list-tile-title>
          </v-list-tile>
          <v-list-tile  @click="redirect(item)" :key="index" v-if="!item.needPermission">
                <v-list-tile-action>
                <v-icon v-html="item.icon" color="grey darken-3"></v-icon>
              </v-list-tile-action>
              <v-list-tile-title><span class="grey--text text--darken-3">{{ item.title }} </span></v-list-tile-title>
          </v-list-tile>
        </template>
      </v-list>
    </v-menu>
    </v-toolbar>

    <!-- content -->
    <v-content>
      <transition name="fade">
        <router-view/>
      </transition>

      <loader></loader>
    </v-content>
  </v-app>
</template>

<script>
import router from '.././router'
import Store from '.././store'
import Loader from './Loader'

export default {
  components: {
    Loader
  },
  name: 'App',
  data () {
    return {
      clipped: false,
      drawer: false,
      fixed: false,
      avatarSize: 32,
      tile: true,
      items: [
        /*{
          icon: 'home',
          title: 'Domov'
        },*/

        /*{
          icon: 'verified_user',
          title: 'Ponastavitev gesla',
          routeName: 'password-reset'
        },*/
        {
          icon: 'graphic_eq',
          title: 'Validacije',
          routeName: 'validator',
          needPermission: false
        },
        {
          icon: 'assignment_ind',
          title: 'Vpis uporabnika',
          routeName: 'rfid',
          needPermission: true
        },
        {
          icon: 'supervisor_account',
          title: 'Seznam uporabnikov',
          routeName: 'seznam-uporabnikov',
          needPermission: true
        },
        {
          icon: 'lock_open',
          title: 'Odjava',
          routeName: 'login',
          needPermission: false

        }
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Garažna hiša Vurnikov trg - Radovljica',
      footer_content: new Date().getFullYear() + " - " + " Conforma d.o.o." 
    }
  },

  computed: {
    currentUser() {
      return this.$store.getters.user
    },

    hasPermissions() {
      if(this.$store.getters.permissions.includes('root') || this.$store.getters.permissions.includes('rfid_uporabniki')) {
        return true;
      }

      return false;
    }
  },

  methods: {
    redirect(item) {
      if (item.title == 'Odjava') {
        this.$store.commit('setLoaderText', 'Odjava uporabnika je v teku...')
        this.$store.commit('setLoader', true)
        this.$store.dispatch('LOGOUT')
          .then(response => {
            setTimeout(() => {
              this.$store.commit('setLoader', false) 
              router.push({
                name: 'login'
              })
            }, 500)
          })
          .catch(error =>{
            setTimeout( () => {
              this.$store.commit('setLoader', false) 
            })

            window.console.log('Logout error')
            window.console.log(error)

          })
          .then(() => {

          })
      } 
      else {
        router.push({
          name: item.routeName
        });
      }
    },

    redirectHome () {
      this.$router.push({
        name: 'validator'
      })
    }
  },

  created() {
    this.$store.dispatch('USER_DATA')
      .then(response => {
        
      })
      .catch(error => {
        this.$toasted.show("Pri pridobivanju podatkov je prišlo do napake.", {
              position: 'bottom-right',
              duration: 5000,
              icon: 'error_outline',
              theme: 'bubble', //['primary', 'outline' , 'bubble']
              closeOnSwipe: true
            })
      })
      .then(() => {

      })
  }
}
</script>

<style>
  .pointer {cursor: pointer;}
  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .25s;
  }

  .fade-enter-active {
    transition-delay: .25s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }
</style>

